import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import topLogo from "../../../../../assets/top/top_logo.png";
import {
  container,
  innerContainer,
  menuSection,
  mainSection,
  imageContainer,
  menuImage,
  menuImageContent,
  imageTextOverlay,
  overlayTitle,
  overlayDescription,
  contentContainer,
  menuContent,
  foodItemWrapper,
  foodText,
  foodImage,
  foodImageContent,
  foodTitle,
  foodDescription,
  foodNote,
  menuLogo,
} from "../menuPage.css.ts";
import MenuSection from "../components/MenuSection";
import MobileHeader from "../components/MobileHeader";

// 画面幅判定用フック
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);
  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= breakpoint);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [breakpoint]);
  return isMobile;
}

interface MenuItem {
  title: string;
  description: string;
  price: string;
  image: string;
}

const TakeoutMenuPage: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const menuItems: MenuItem[] = [
    {
      title: '発芽酵素玄米',
      description: '当店自慢の発芽酵素玄米は3日間保温熟成させることで酵素が活性化、栄養価が高く消化吸収に優れています。手間をかけずに体に優しく健康的な玄米食生活を手に入れられます。',
      price: '¥1,350(税込)（1パック）',
      image: new URL('../../../../../assets/kousogenmai.jpg', import.meta.url).href
    },
    {
      title: '酵素玄米弁当',
      description: 'KitchenMüküの酵素玄米プレートをご自宅でもお楽しみいただけます。発芽酵素玄米を主食に、手造り麹調味料で味付けした野菜中心で栄養バランスの取れたお弁当。5個以上で予約注文可能です。',
      price: '¥2,500(税込)〜',
      image: new URL('../../../../../assets/bentou.jpg', import.meta.url).href
    },
    {
      title: '玄米豆乳甘酒',
      description: '飲む点滴・飲む美容液とも呼ばれる砂糖不使用ノンアルコールで安心の玄米甘酒に豆乳を加え、大豆の栄養と米麹の甘みが絶妙に調和、匂いも気にならない当店自慢の玄米豆乳甘酒。優しい味をお楽しみいただけます。',
      price: '¥648(税込)（200ml）',
      image: new URL('../../../../../assets/amazake.jpg', import.meta.url).href
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={container}>
      <div className={innerContainer}>
        <MobileHeader />
        <div className={menuSection}>
          <img
            src={topLogo}
            alt="キッチンムク"
            className={menuLogo}
            onClick={() => navigate('/')} 
            style={{ cursor: 'pointer' }}
          />
          <MenuSection />
        </div>
        <div className={mainSection}>
          <div className={imageContainer}>
            <div className={menuImage}>
              <img
                src={new URL('../../../../../assets/Takeoutmenytop.jpg', import.meta.url).href}
                alt="takeout"
                className={menuImageContent}
              />
              <div className={imageTextOverlay}>
                <h1 className={overlayTitle}>テイクアウト</h1>
                <p className={overlayDescription}>
                  お家でヘルシー&美味しいKitchenMüküの味をお楽しみいただけます。
                </p>
              </div>
            </div>
          </div>
          <div className={contentContainer}>
            <div className={menuContent}>
              {menuItems.map((item, idx) => (
                <div key={idx} className={foodItemWrapper}>
                  {isMobile ? (
                    <div className={foodText} style={{ width: "100%" }}>
                      <div className={foodTitle}>{item.title}</div>
                      <div className={foodImage}>
                        <img src={item.image} alt={item.title} className={foodImageContent} />
                      </div>
                      <div className={foodDescription}>{item.description}</div>
                      <div className={foodNote}>{item.price}</div>
                    </div>
                  ) : (
                    <>
                      <div className={foodText}>
                        <div className={foodTitle}>{item.title}</div>
                        <div className={foodDescription}>{item.description}</div>
                        <div className={foodNote}>{item.price}</div>
                      </div>
                      <div className={foodImage}>
                        <img src={item.image} alt={item.title} className={foodImageContent} />
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TakeoutMenuPage; 